import { IAppState } from '../../redux';
import { selectConfigValue } from '../config';
import { selectIsByHomeowner, selectIsDailyRentOffer } from '../offer';

export const selectIsRealtyCalendarBannerAvailable = (state: IAppState): boolean => {
  const isRealtyCalendarIntegrationEnabled = selectConfigValue('isRealtyCalendarIntegrationEnabled', state);
  const isDailyRentOffer = selectIsDailyRentOffer(state);
  const isByHomeowner = selectIsByHomeowner(state);
  const isRealtyCalendarForHomeownersEnabled = selectConfigValue('isRealtyCalendarForHomeownersEnabled', state);

  const isRealtyCalendarForHomeownersAvailable = !isByHomeowner || isRealtyCalendarForHomeownersEnabled;

  return isRealtyCalendarIntegrationEnabled && isRealtyCalendarForHomeownersAvailable && isDailyRentOffer;
};
